import { render, staticRenderFns } from "./metrics_student_performance.vue?vue&type=template&id=679a2301&scoped=true&"
import script from "./metrics_student_performance.vue?vue&type=script&lang=js&"
export * from "./metrics_student_performance.vue?vue&type=script&lang=js&"
import style0 from "./metrics_student_performance.vue?vue&type=style&index=0&id=679a2301&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679a2301",
  null
  
)

export default component.exports